import { render, staticRenderFns } from "./Exportar.vue?vue&type=template&id=895dfca0&"
import script from "./Exportar.vue?vue&type=script&lang=ts&"
export * from "./Exportar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports